export default __webpack_public_path__ + "static/media/assets-film_03.909f6886.jpg";